/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetOrderByIdOptions, GetOrderByIdResponses } from '../types/GetOrderById'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Get details of a specific order. Traders can only view their own orders. Admins can view any order. Integrators can view orders for users within their tenant.
 * @summary Get order by ID
 * {@link /v1/orders/:order_id}
 */
export function getOrderById<ThrowOnError extends boolean = true>(
  options: Options<GetOrderByIdOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetOrderByIdResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/orders/{order_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetOrderByIdResponses, ThrowOnError>>,
  )
}
